import React, { createContext, useReducer } from 'react';

// Создаем контекст пользователя
export const UserContext = createContext({});

// Начальное состояние пользователя
const initialState = {
  user: null,
  isAuthenticated: false,
  loading: true,
  users: [],
  hostname: process.env.REACT_APP_API_URL || "" //process.env.REACT_APP_API_URL
};

// Редьюсер для изменений состояния пользователя
const reducer = (state, action) => {
  switch (action.type) {
    case 'ADD_USER':
      return {
        ...state,
        users: [...state.users, action.payload.user],
      };
    case 'LOGIN':
      return {
        ...state,
        id: action.payload.id,
        roleId: action.payload.roleId,
        user: action.payload.user,
        role: action.payload.role,
        email: action.payload.email,
        isAuthenticated: true,
        loading: false,
      };
    case 'LOGOUT':
      return {
        ...state,
        user: null,
        email: null,
        isAuthenticated: false,
        loading: false,
      };
    case 'CHECKOUT':
        return {
            ...state,
            user: action.payload.user,
            id: action.payload.id,
            role: action.payload.role,
            email: action.payload.email,
            roleId: action.payload.roleId,
            isAuthenticated: action.payload.checkout
        }
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload.loading,
      };
    case 'UPDATE_USER':
      return {
        ...state,
        users: state.users.map(u =>
          u._id === action.payload.id ? { ...u, ...action.payload.UPDuser } : u
        ),
      };
    case 'DELETE_USER':
      return {
        ...state,
        users: state.users.filter(user => user._id !== action.payload.id),
      };
    case "ALL_USERS":
      return {
        ...state,
        users: action.payload.users
      }
    case "ALL_ROLES":
      return {
        ...state,
        roles: action.payload.roles
      }
    default:
      return state;
  }
};

// Провайдер контекста пользователя
export const UserProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const checkUsers = async () => {
    try {
      const response = await fetch(initialState.hostname+'/users/getUsersLength', {
        method: 'get',
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.log(error);
    }
  }

  const login = async (credentials) => {
    try {
      // Симуляция асинхронного процесса логина
      const response = await fetch(initialState.hostname+'/users/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.success) {
      localStorage.setItem('authToken', JSON.stringify({token:data.data.accessToken, user: data.data.name, role:data.data.roleName, id: data.data.id, roleId: data.data.role, email: data.data.email}));    
        dispatch({
          type: 'LOGIN',
          payload: { id: data.data.id, roleId: data.data.role, user: data.data.name, role: data.data.roleName, email: data.data.email?data.data.email : "" },
        });
      }
    
    } catch (err) {
      console.error(err);
    }
  };

    const firstUser = async (credentials) => {
    try {
        
      // Симуляция асинхронного процесса логина
      const response = await fetch(initialState.hostname+'/users/firstCreate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.success) {
        
      }
    
    } catch (err) {
      console.error(err);
    }
  };

    const createUser = async (credentials) => {
    try {
        
      // Симуляция асинхронного процесса логина
      const response = await fetch(initialState.hostname+'/users/create', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      if (data.success) {
        dispatch({
          type: 'ADD_USER',
          payload: { user: {_id:data.data._id, ...credentials} },
        });
      }
    
    } catch (err) {
      console.error(err);
    }
  };

  const getUsers = async () => {
    try {
      const response = await fetch(initialState.hostname+'/users/getUsers', {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      dispatch({
          type: 'ALL_USERS',
          payload: { users: data.data },
        });
      return data;
    } catch (error) {
      console.log(error);
    }
  }

  const getRoles = async () => {
    try {
      const response = await fetch(initialState.hostname+'/roles/getRoles', {
        method: 'get',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      dispatch({
          type: 'ALL_ROLES',
          payload: { roles: data.data },
        });
      return data;
    } catch (error) {
      console.log(error);
    }
  }

    const updateUser = async (credentials) => {
    try {
      let id = credentials._id;
      delete credentials._id;
      const response = await fetch(initialState.hostname+'/users/update/'+id, {
        method: 'put',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        },
        body: JSON.stringify(credentials)
      });
      const data = await response.json();
      dispatch({
          type: 'UPDATE_USER',
          payload: { UPDuser: {...credentials, _id:id}, id:id },
        });
      return data;
    } catch (error) {
      console.log(error);
    }
  }

  const checkout = (token) => {
    token = JSON.parse(token)
    dispatch({
                type: 'CHECKOUT',
                payload: { checkout: true, user: token.user, role: token.role, id: token.id, roleId: token.roleId, email: token.email },
            });
  }

  const deleteUser = async id => {
    try {
      const response = await fetch(initialState.hostname+'/users/user/'+ id, {
        method: 'delete',
        headers: {
          'Content-Type': 'application/json',
          'x-access-token': JSON.parse(localStorage.getItem('authToken')).token
        }
      });
      const data = await response.json();
      if (data.isLoggetIn !== undefined && data.isLoggetIn === false){
        logout();
      }
        dispatch({ type: 'DELETE_USER', payload: { id } });
        return data;
    } catch (error) {
      console.log(error);
    }
  }

  const logout = () => {
    localStorage.removeItem('authToken');
    dispatch({ type: 'LOGOUT' });
  };

  return (
    <UserContext.Provider value={{ ...state, login, logout, checkout, checkUsers, firstUser, createUser, getRoles, getUsers, updateUser, deleteUser}}>
      {children}
    </UserContext.Provider>
  );
};

// Функция для удобного использования контекста
export const useUserContext = () => {
  const context = React.useContext(UserContext);
  if (!context) throw new Error("useUserContext must be used within a UserProvider");
  return context;
};